import script from "./ExtratoMensalidadesMatriculas.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtratoMensalidadesMatriculas.vue?vue&type=script&setup=true&lang=js"

import "./ExtratoMensalidadesMatriculas.vue?vue&type=style&index=0&id=582ebf24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-582ebf24"]])

export default __exports__